import Immutable from 'immutable';

export interface RawStudioFolderImportRequest {
  id: number;
  studioprojectid: string;
}

export interface StudioFolderImportRequestData {
  id: number;
  studioprojectid: string;
}

const defaultValues: StudioFolderImportRequestData = {
  id: 0,
  studioprojectid: '',
};

export const StudioFolderImportRequestFactory = Immutable.Record(
  defaultValues,
  'StudioFolderImportRequest'
);

export class StudioFolderImportRequest extends StudioFolderImportRequestFactory {
  static deserialize(
    rawStudioFolderImportRequest: StudioFolderImportRequestData
  ): StudioFolderImportRequestData {
    return new StudioFolderImportRequest({ ...rawStudioFolderImportRequest });
  }

  serialize(): RawStudioFolderImportRequest {
    return this.toJS();
  }
}

export type StudioFolderImportRequestList =
  Immutable.List<StudioFolderImportRequest>;
